module.exports = __webpack_public_path__ + "img/swiper3.c4874059.jpg";